// Components
import RenderDateWithFromTime from '@/common-utils/components/renders/date/RenderDateWithFromTime';
import DropdownMerchantAccountActionsRow from '../../dropdown/DropdownMerchantAccountActionsRow';
import DetailsButton from '@/common-utils/components/renders/detailsButton/DetailsButton';
import { Badge } from '@/common-utils/components/ui/badge';
// Common
import merchantAccountsFields from '../../../fields/merchantAccountFields';
import MERCHANT_ACCOUNT_STATUS from '../../../enums/merchantAccountStatus';
import RouteUrls from '@/app/root/enums/RouteUrls';
import generateColumnDefByField from '@/common-utils/functions/generateColumnDefByField';
import Permissions from '@/app/permissions/Permissions';

export const columnsMerchantAccountId = 'merchant_accounts';
export const columnsMerchantAccount = (headerPackage) => {

    return ([
        generateColumnDefByField({
            field: merchantAccountsFields.DETAILS,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                <DetailsButton
                    pathParams={{ contractAccessId: row.original.uuid }}
                    baseUrl={RouteUrls.MERCHANT_ACCOUNT_DETAILS.url}
                    requiredPermissions={[Permissions.CONTRACTS_ACCESS_READ.name]}
                />
            )
        }),
        generateColumnDefByField({
            field: merchantAccountsFields.UUID,
            headerPackage: headerPackage,
            customCellFn: ({ row }) => (
                row &&
                <DropdownMerchantAccountActionsRow merchantAccount={row.original} setLaunchRefetch={headerPackage.setLaunchRefetch} />
            )
        }),
        generateColumnDefByField({
            field: merchantAccountsFields.LABEL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: merchantAccountsFields.STATUS,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => {
                const status = MERCHANT_ACCOUNT_STATUS[cell.getValue()];
                return (
                    status &&
                    <Badge entity={status.entity} namespace={status.namespace} variant={status.variant} />
                );
            }
        }),
        generateColumnDefByField({
            field: merchantAccountsFields.EMAIL,
            headerPackage: headerPackage,
            isLongText: true
        }),
        generateColumnDefByField({
            field: merchantAccountsFields.CREATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(merchantAccountsFields.CREATED_AT.key)} />
            )
        }),
        generateColumnDefByField({
            field: merchantAccountsFields.UPDATED_AT,
            headerPackage: headerPackage,
            customCellFn: ({ cell }) => (
                cell &&
                <RenderDateWithFromTime value={cell.getValue(merchantAccountsFields.UPDATED_AT.key)} />
            )
        })
    ]);
};